import { configureStore } from "@reduxjs/toolkit";
import { cryptoApi } from "../components/sevices/cryptoApi";
import { cryptoNewsApi } from "../components/sevices/cryptoNewsApi";


export const store= configureStore({

    reducer:{
        [cryptoApi.reducerPath]: cryptoApi.reducer,
        [cryptoNewsApi.reducerPath]:cryptoNewsApi.reducer,
    },
});